<template>
  <el-dialog
    :title="isEdit ? '编辑标签' : '新增标签'"
    :visible.sync="visible"
    width="540px"
    :close-on-click-modal="false"
    @closed="resetForm"
  >
    <el-form ref="form" :model="form" label-width="100px" size="medium">
      <el-form-item label="标签名称" required>
        <el-input v-model="form.name" placeholder="请输入标签名称" @input="suggestCode" v-bind:disabled="isDisable"></el-input>
      </el-form-item>
      <el-form-item label="业务类型" required>
        <el-select v-model="form.businessType" style="width: 100%;" placeholder="请选择" filterable v-bind:disabled="isDisable">
          <el-option
            v-for="item in businessTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="主标签">
        <el-select v-model="form.labelMain" placeholder="无（作为主标签）" style="width:100%" filterable clearable>
          <el-option
            v-for="tag in availableParentTags"
            :key="tag.id"
            :label="`[${tag.name}]`"
            :value="tag.name"
          ></el-option>
        </el-select>
        <span class="form-hint">定时策略按主标签走</span>
      </el-form-item>
      <el-form-item label="状态" required>
        <el-select v-model="form.status" style="width:100%">
          <el-option label="启用中" :value="true"></el-option>
          <el-option label="已停用" :value="false"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!isGeneralPool" label="语料优先级">
        <el-input-number v-model="form.priority" :min="1" style="width:100%"></el-input-number>
        <span class="form-hint">数字越小优先级越高，决定label是否替换</span>
      </el-form-item>
      <el-form-item label="平台优先级" required>
        <el-input-number v-model="form.platformPriority" :min="1" style="width:100%"></el-input-number>
      </el-form-item>
      <el-form-item label="联系状态" required>
        <el-select v-model="form.contactStatus" style="width: 100%;" placeholder="请选择" filterable v-bind:disabled="isDisable">
          <el-option
            v-for="item in contactStatusOption"
            :key="item.modelCode"
            :label="item.modelName"
            :value="item.modelCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="案件状态" required>
        <el-select v-model="form.caseStatus" style="width: 100%;" placeholder="请选择" filterable v-bind:disabled="isDisable">
          <el-option
            v-for="item in caseStatusOption"
            :key="item.modelName"
            :label="item.modelName"
            :value="item.modelName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标签描述" required>
        <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="描述该标签的业务逻辑" v-bind:disabled="isDisable"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="onConfirm">确认保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { BUSINESS_TYPE_OPTIONS } from '../../../utils/business-type';

export default {
  name: 'TagFormDialog',
  props: {
    poolType: { type: String, default: 'general' },
    allTags: { type: Array, default: () => [] },
    editTag: { type: Object, default: null },
    companyBusinessType: { type: String, default: '' },
    selectedCompany: { type: [String, Number], default: '' },
    caseStatusOption: { type: Array, default: () => [] },
    contactStatusOption: { type: Array, default: () => [] },
    filteredTags: { type: Array, default: () => [] }
  },
  data() {
    return {
      businessTypeOptions: BUSINESS_TYPE_OPTIONS,
      visible: false,
      labelList: [],
      form: {
        id: '',
        name: '',
        priority: 1,
        platformPriority: 1,
        labelMain: '',
        remark: '',
        caseStatus: '',
        contactStatus: '',
        companyId: '',
        status: null,
        targetId: null,
        targetType: null,
        businessType: 'general',
        isCanEdit: ''
      },
      isDisable: false,
      isCommon: null
    };
  },
  computed: {
    isEdit() {
      return !!this.editTag;
    },
    isGeneralPool() {
      return this.poolType === 'general';
    },
    isCompanyOwn() {
      return this.poolType === 'company-own';
    },
    availableParentTags() {
      return this.allTags.filter(t => t.id !== (this.editTag && this.editTag.id));
    }
  },
  watch: {
    visible(val) {
      if (val) this.initForm();
    }
  },
  methods: {
    open() {
      this.visible = true;
    },
    initForm() {
      const tag = this.editTag || {};
      this.form.id = tag.id || '';
      this.form.name = tag.name || '';
      this.form.labelMain = tag.labelMain || '';
      if (tag.name === tag.labelMain) {
        this.form.labelMain = '';
      }
      this.form.priority = tag.priority || 1;
      this.form.platformPriority = tag.platformPriority || 1;
      this.form.remark = tag.remark || '';
      this.form.caseStatus = tag.caseStatusStr || tag.caseStatus || '';
      this.form.contactStatus = tag.contactStatus || '';
      this.form.companyId = tag.companyId || this.selectedCompany || 0;
      if (!this.isEdit) {
        // 新增
        this.form.businessType = this.isCompanyOwn ? this.companyBusinessType : 'general';
        this.form.priority = this.allTags.length + 1;
        this.form.isCanEdit = true;
        this.isDisable = false;
        this.form.status = true;
        this.isCommon = this.isGeneralPool;
      } else {
        // 编辑
        this.form.businessType = !tag.isCommon ? this.companyBusinessType : tag.businessType || 'general';
        this.form.isCanEdit = tag.isCanEdit;
        this.isDisable = !this.form.isCanEdit;
        this.form.status = tag.status;
        this.isCommon = tag.isCommon;
      }
      if (this.isGeneralPool) {
        this.form.groupId = 0;
      } else {
        this.form.groupId = tag.groupId || 0;
      }
      this.form.targetId = null;
      this.form.targetType = null;
    },
    resetForm() {
      this.$emit('closed');
    },
    suggestCode() {
      if (!this.isEdit) {
        const name = this.form.name;
        const mapping = { '用户': 'user', '忠诚度': 'loyalty', '等级': 'level', '风险': 'risk', '评分': 'score', '逾期': 'overdue', '保险': 'ins', '营销': 'marketing', '客户': 'customer', '投诉': 'complaint', '活跃': 'active', '失联': 'lost', '意向': 'intent', '渠道': 'channel', '服务': 'service', '偏好': 'preference' };
        let suggested = '';
        Object.keys(mapping).forEach((key) => {
          if (name.includes(key)) {
            suggested += (suggested ? '_' : '') + mapping[key];
          }
        });
        this.form.code = suggested || `tag_${Math.floor(Math.random() * 1000)}`;
      }
    },
    onConfirm() {
      if (!this.checkAddOrEditParmas()) return;
      this.form.companyId = this.selectedCompany || this.form.companyId || 0;
      this.form.labelMain = this.form.labelMain || this.form.name;
      this.$ajax({
        url: '/label/addOrEditLabelNew',
        prompt: true,
        method: 'POST',
        data: this.form
      })
        .then(() => {
          this.$message.success(this.isEdit ? '标签已更新' : '标签已创建');
          this.visible = false;
          this.$emit('confirm', { ...this.form });
        });
    },
    checkAddOrEditParmas() {
      if (!this.form.name) {
        this.$message({
          message: '请输入标签名称',
          type: 'warning'
        });
        return false;
      }
      if (!this.form.platformPriority) {
        this.$message({
          message: '请输入平台优先级',
          type: 'warning'
        });
        return false;
      }
      if (!this.form.remark) {
        this.$message({
          message: '请输入标签描述',
          type: 'warning'
        });
        return false;
      }
      if (!this.form.contactStatus) {
        this.$message({
          message: '请选择联系状态',
          type: 'warning'
        });
        return false;
      }
      if (!this.form.caseStatus) {
        this.$message({
          message: '请选择案件状态',
          type: 'warning'
        });
        return false;
      }
      if (!this.isCommon && this.form.businessType !== this.companyBusinessType) {
        // 不是通用标签池添加,需要校验业务标签
        this.$message({
          message: '请选择与公司类型相符的业务类型',
          type: 'warning'
        });
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="less" scoped>
.form-hint {
  font-size: 12px;
  color: #c0c4cc;
  display: block;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/page/main/tagpools/tag-form-dialog.vue